import Membership from "@/domain/order/Membership";
import {GetterTree, Module, MutationTree} from "vuex";

export class MembershipState {
  public orderPrice: number;
  public pointAmount: number;
  public pointUseAmount: number;
  public chargeCardAmount: number;
  public chargeCardTotalUseAmount: number;
  public chargeCards: Array<Membership>;

  constructor() {
    this.orderPrice = 0;
    this.pointAmount = 0;
    this.pointUseAmount = 0;
    this.chargeCardAmount = 0;
    this.chargeCardTotalUseAmount = 0;
    this.chargeCards = [];
  }
}

const getters: GetterTree<MembershipState, any> = {
  hasChargeCard(state: MembershipState): boolean {
    return state.chargeCards.length > 0;
  },
  isAlreadyAddedCard:(state: MembershipState) => (cardNo: string): boolean => {
    for (let i=0; i<state.chargeCards.length; i++) {
      if (state.chargeCards[i].cardNo === cardNo) {
        return true;
      }
    }
    return false;
  }
};

const mutations: MutationTree<MembershipState> = {
  setOrderPrice(state: MembershipState, price: number): void {
    state.orderPrice = price;
  },
  setPointAmount(state: MembershipState, amount: number): void {
    state.pointAmount = amount;
  },
  setPointUseAmount(state: MembershipState, amount: number): void {
    state.pointUseAmount = amount;
  },
  setChargeCardTotalUseAmount(state: MembershipState, amount: number): void {
    state.chargeCardTotalUseAmount = amount;
  },
  addChargeCard(state: MembershipState, chargeCard: Membership): void {
    state.chargeCards.push(new Membership(chargeCard));
    state.chargeCardAmount += chargeCard.restPoint;
  },
  setSelectedChargeCardList(state: MembershipState, chargeCardList: Array<Membership>): void {
    state.chargeCards = [];
    chargeCardList.forEach((chargeCard: Membership) => {
      state.chargeCards.push(new Membership(chargeCard));
    });
  },
  clearSelectedChargeCardList(state: MembershipState): void {
    state.chargeCardTotalUseAmount = 0;
    state.chargeCards.forEach(chargeCard => {
      chargeCard.usePoint = 0;
      chargeCard.selected = false;
    });
  },
  initMembershipStore(state: MembershipState): void {
    state.orderPrice = 0;
    state.pointAmount = 0
    state.pointUseAmount = 0;
    state.chargeCardAmount = 0;
    state.chargeCardTotalUseAmount = 0;
    state.chargeCards = [];
  }
};

export const MembershipStore: Module<MembershipState, any> = {
  namespaced: true,
  state: new MembershipState(),
  getters,
  mutations
};